// src/modules/LiberacoesFinanceiras/services/ddaPaymentService.js
import { fetchData } from '../../../utils/datasource';

/**
 * Fetches all pending payments
 * @returns {Promise<Array>} Array of payment objects
 * @throws {Error} If the API request fails
 */
export const fetchPayments = async () => {
  console.log('Fetching payments from /sibeapp/liberafin/dda/');
  
  try {
    const response = await fetchData(
      '/sibeapp/liberafin/dda/',
      'GET',
      {},
      30000
    );

    console.log('Payments response:', response);

    if (!response.ok) {
      throw new Error('Failed to fetch payments');
    }

    const result = await response.json();
    console.log('Parsed result:', result);

    if (result.status !== 'ok') {
      throw new Error('Failed to fetch payments');
    }

    // Map API fields to expected format
    const payments = result.data.map(item => ({
      E2_FILIAL: item['FILIAL\t'] || item.FILIAL,
      E2_PREFIXO: item.PREFIXO,
      E2_NUM: item.NUM,
      E2_PARCELA: item.PARCELA,
      E2_TIPO: item.TIPO,
      E2_FORNECE: item.FORNECE,
      E2_LOJA: item.LOJA,
      E2_NOMFOR: item.NOMFOR,
      E2_FILORIG: item.FILORIG,
      E2_VENCREA: item.VENCREA,
      E2_EMISSAO: item.EMISSAO,
      E2_XUUID: item.XUUID,
      E2_XVALDDA: item.XVALDDA,
      E2_RECNO: item.RECNO
    }));

    console.log('Mapped payments:', payments);
    return payments;
  } catch (error) {
    console.error('Error fetching payments:', error);
    throw error;
  }
};

/**
 * Authorizes a payment by sending all required parameters via query string
 * @param {Object} payment - Payment object with all required fields
 * @returns {Promise<Object>} Response from the API
 * @throws {Error} If the API request fails
 */
export const authorizePayment = async (payment) => {
  console.log('Authorizing payment:', payment);



  try {
    // Build query parameters
    const queryParams = new URLSearchParams({
      XUUID: payment.E2_XUUID || '',
      XVALDDA: payment.E2_XVALDDA || '',
      E2FILIAL: payment.E2_FILIAL || '',
      E2PREFIXO: payment.E2_PREFIXO || '',
      E2NUM: payment.E2_NUM || '',
      E2PARCELA: payment.E2_PARCELA || '',
      E2TIPO: payment.E2_TIPO || '',
      E2FORNECE: payment.E2_FORNECE || '',
      E2LOJA: payment.E2_LOJA || '',
      E2NOMFOR: payment.E2_NOMFOR || '',
      E2FILORIG: payment.E2_FILORIG || ''
    }).toString();

    const url = `/sibeapp/liberafin/dda/autorizar?${queryParams}`;
    console.log('Authorization URL:', url);
    
    const response = await fetchData(
      url,
      'POST',
      {},
      30000
    );

    console.log('Authorization response:', response);

    if (!response.ok) {
      throw new Error('Failed to authorize payment');
    }

    const result = await response.json();
    console.log('Authorization result:', result);

    return result;
  } catch (error) {
    console.error('Error authorizing payment:', error);
    throw error;
  }
};

/**
 * Updates payment status
 * @param {string} numero - Payment number
 * @returns {Promise<Object>} Response from the API
 * @throws {Error} If the API request fails
 */
export const updatePaymentStatus = async (numero) => {
  console.log('Updating payment status for numero:', numero);

  // Mock success response
  await new Promise(resolve => setTimeout(resolve, 500));
  return { status: 'ok', message: 'Payment status updated successfully' };

  // Real API call - uncomment when ready to connect
  /*
  try {
    const response = await fetchData(
      `/sibeapp/liberacao_financeiras/boletos_pagamento/${numero}`,
      'POST',
      {},
      30000
    );

    if (!response.ok) {
      throw new Error('Failed to update payment status');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error updating payment status:', error);
    throw error;
  }
  */
};
